import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import abs1 from "../../assets/Group39264.png";
import abs2 from "../../assets/white39265.png";
import { postRequest } from "../../utils/axiosrequest";
import { Country } from "../../utils/Country";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Header3 from "../../components/Header/Header3";
import "./login.scss";

const NewLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userMobile = location?.state?.phone_no;

  useEffect(() => {
    document.title = "Login | Ballers";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const token = "Bearer YmFsbGVyc29mZmljaWFsbGl2ZXdlYnNpdGV0b2tlbjIwMjQ=";

  const [Code, setCode] = useState("+91");
  const [hidden, sethidden] = useState(true);
  const [User, setUser] = useState({
    country_code: Code,
    phone_no: userMobile || "",
    status: "under_review",
  });
  const [isTrimmed, setIsTrimmed] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // Loading state

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const selectedCountry = Country.find(
      (country) => country.dial_code === User.country_code
    );

    if (name === "phone_no") {
      const maxLength = selectedCountry.phone_length;

      if (value.length > maxLength) {
        const trimmedValue = value.slice(0, maxLength);
        setUser({ ...User, [name]: trimmedValue });
        setIsTrimmed(true);
        // console.log(`Phone number trimmed: ${value} to ${trimmedValue}`);
      } else {
        setUser({ ...User, [name]: value });
        setIsTrimmed(false);
      }
    } else {
      setUser({ ...User, [name]: value });
    }
  };

  const handleformSubmit = async (e) => {
    e.preventDefault();
    const endpoint = `memberships/baller_member/member_login`;

    if (User.phone_no.length < 10) {
      toast.error("Please enter a valid phone number");
      return;
    }

    setIsLoading(true); // Start loading

    try {
      const res = await postRequest(endpoint, User, token);
      if (res.status === 200) {
        navigate("/verifyOTP", { state: { phone_no: User.phone_no } });
      } else if (res.response.status > 400) {
        setUser({
          country_code: Code,
          phone_no: "",
        });
        toast.error(res.response.data.detail);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    } finally {
      setIsLoading(false); // Stop loading after request completes
    }
  };

  return (
    <div className="request_section">
      <div className="request_content">
        <Header3 />
        <div className="form">
          <div className="title_signUp">
            <h2>
              <div className="abs1">
                <img src={abs1} alt="" />
              </div>
              One Membership <br /> Unlimited Sports
              <p className="breakLineSignUp"> </p>
            </h2>
            <div className="info">
              <div className="rectangle"></div>
              <p>
                Play. Compete. Socialize. Anytime. Anywhere.
                <div className="abs2">
                  <img src={abs2} alt="" />
                </div>
              </p>
            </div>
          </div>
          <div className="form_wrapper">
            <form onSubmit={handleformSubmit}>
              <p className="loginTxt">Login</p>
              <p className="tagLine">
                We’ll send you a magic code for a password-free sign in
              </p>
              <div className="phonenumberLogin">
                <div className="code" onClick={() => sethidden(!hidden)}>
                  {Code}
                  {hidden ? (
                    <KeyboardArrowDownIcon />
                  ) : (
                    <KeyboardArrowUpIcon style={{ color: "lightgreen" }} />
                  )}
                </div>
                {hidden ? null : (
                  <div className="countrycode">
                    {Country.map((country) => (
                      <div
                        key={country.code}
                        onClick={() => {
                          sethidden((prev) => !prev);
                          setCode(country.dial_code);
                          setUser({
                            ...User,
                            country_code: country.dial_code,
                          });
                        }}
                      >
                        {country.name + " " + country.dial_code}
                      </div>
                    ))}
                  </div>
                )}
                <input
                  type="text"
                  id="phone_no"
                  name="phone_no"
                  pattern="[0-9]*"
                  placeholder="Enter your WhatsApp number"
                  required
                  value={User.phone_no}
                  onChange={handleInputChange}
                />
                {isTrimmed && (
                  <div className="errorCodeForPhone">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#9a1717"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-info"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 16v-4" />
                      <path d="M12 8h.01" />
                    </svg>
                  </div>
                )}
              </div>
              <div className="checkBoxDiv">
                <div>
                  <input
                    type="checkbox"
                    name="terms"
                    required
                    value="terms"
                    checked
                  />
                </div>
                <p className="checkBoxTxt">
                  By continuing, you agree to{" "}
                  <a href="/termsandcondition" className="link">
                    Ballers Terms of Use
                  </a>{" "}
                  and{" "}
                  <a href="/privacypolicy" className="link">
                    Privacy Policy
                  </a>
                  .
                </p>
              </div>
              <button type="submit" disabled={isLoading}>
                {/* {isLoading ? "Please Wait..." : "Get Started"} */}
                Get OTP
              </button>
              <p className="signUpTxt">
                Don't have an account? 
                <a className="link2" href="/signUp">
                  Sign up
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewLogin;
